import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { ConfigProvider, Flex } from "antd"
import ReactQueryProvider from "context/ReactQueryProvider"
import { HelmetProvider } from "react-helmet-async"
import App from "app/App"

// theme
import { primaryTheme } from "styles/theme"

// context
import AppContextProviders from "context/AppContextProviders"

// api
import useQueryClient from "api/utils/useQueryClient"

const AppProviders = () => {
  const { queryClient, toastContextHolder } = useQueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={primaryTheme}
        form={{
          validateMessages: {
            required: (
              <Flex
                align="center"
                gap={6}
              >
                <i className="fal fa-exclamation-circle" />
                <span className="prime-error-text">This is a required field.</span>
              </Flex>
            ),
            types: {
              email: "Enter a valid email.",
              url: "Enter a valid URL starting with https://.",
            },
          },
        }}
      >
        <ReactQueryProvider>
          <AppContextProviders>
            <HelmetProvider>
              {toastContextHolder}
              <App />
            </HelmetProvider>
          </AppContextProviders>
        </ReactQueryProvider>
      </ConfigProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default AppProviders
